(($) => {
  window.vt = window.vt || {}

  vt.FullWidthSlider = (() => {
    const initialize = (element) => {
      const isAFI = $('html').hasClass('afi')

      const configOptions = {
        adaptiveHeight: true,
        mode: 'horizontal',
        pager: true,
        onSlideBefore: ($slideElement) => {
          const splitDeck = $slideElement.find('.split-deck')
          const controls = $(element).parent().parent().find('.bx-prev, .bx-next')
          const topValue = splitDeck.length && window.matchMedia('(max-width: 640px)').matches
            ? splitDeck.find(':first-child').height()
            : '50%'
          controls.css('top', topValue)
        },
        onSliderLoad: () => {
          const splitDeck = $(element).find("> div:not([class='bx-clone'])").eq(0).find('.split-deck')
          if (splitDeck.length && window.matchMedia('(max-width: 640px)').matches) {
            $(element).parent().parent().find('.bx-prev, .bx-next')
              .css('top', splitDeck.find(':first-child').height())
          }
        },
        ...(isAFI && {
          adaptiveHeight: false,
          preloadImages: 'visible',
          pager: true,
          pause: 7000,
          oneToOneTouch: false,
          preventDefaultSwipeX: false,
          preventDefaultSwipeY: true,
          wrapperClass: 'bx-wrapper autoslider'
        })
      }

      const slider = $(element).bxSlider(configOptions)
      const sliderOffset = $(element).offset().top
      const viewPortSize = $(window).height()

      if (isAFI) {
        if (viewPortSize < sliderOffset - 200) {
          $(window).scroll(() => slider.startAuto(true))
        } else {
          slider.startAuto(true)
        }
      }
    }

    return { initialize }
  })()
})(jQuery)
